export const HOME_TOUR_TRANSLATIONS = {
  tasksDescription:
    "Vizualizează și gestionează într-un mod rapid toate sarcinile programate pentru ferma ta.",
  notificationsDescription:
    "În widgetul Notificări vei avea acces rapid la ultimele alerte și notificări importante despre activitățile fermei tale.",
  farmSummaryDescription:
    "Obține o imagine de ansamblu asupra întregii ferme, inclusiv numărul de animale în funcție de vârstă și specie.",
  cowsStatusDescription:
    "Pentru că sănătatea și statusul gestațional al efectivului tău de bovine sunt foarte importante, ți-am pregătit un widget unde poți vedea un sumar al stării tuturor bovinelor.",
  myApiariesDescription:
    "Widget dedicat pentru vizualizarea rapidă și interacțiunea cu stupinele tale apicole.",
  myParcelsDescription:
    "O scurtătură pentru a-ți putea accesa parcelele agricole și a afla detalii despre starea lor curentă.",
  cropPlantingsDescription:
    "Vizualizează situația culturilor plantate pe toate parcelele tale agricole.",
  birdGroupsDescription:
    "Scurtătură pentru administrarea și vizualizarea tuturor grupurilor de păsări din ferma ta.",
  weatherDescription:
    "Consultă prognoza meteo locală pentru a-ți planifica eficient activitățile agricole.",
  notesDescription:
    "Accesează rapid notițele și observațiile importante legate de fermă.",
  myHivesDescription:
    "Scurtătură pentru accesarea fiecărui stup, indiferent de stupina din care face parte.",
  myQueensDescription:
    "Urmărește dezvoltarea și vizualizează detaliile reginelor din stupii tăi.",
  virtualAssistantDescription:
    "Obține ajutor și recomandări personalizate pentru administrarea fermei prin intermediul Asistentului Inteligent integrat, care are acces la toate datele fermei tale.",
  gestationalCalendarDescription:
    "Calculează și generează perioadele de gestație și evenimentele importante pentru animalele tale.",
  financialJournalDescription:
    "Analizează și înregistrează veniturile, cheltuielile și situația financiară a fermei tale.",
  startTourModalTitle: "Bună, {{name}}! 👋",
  thankYouForChoosingUs: "Îți mulțumim că ne-ai ales!",
  tutorialPrompt: "Dorești să descoperi aplicația printr-un tur ghidat rapid?",
  tourInProgress: "Turul este în desfășurare...",
  tourCompleted: "Turul a fost finalizat cu succes!",
  tourFailed: "Turul a eșuat. Te rugăm să încerci din nou.",
}
